"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTLE_DEPOSIT_RESPONSE_EXAMPLE = exports.DEBIT_ADVANCE_DEPOSIT_RESPONSE_EXAMPLE = exports.CREDIT_ADVANCE_DEPOSIT_RESPONSE_EXAMPLE = void 0;
const financial_common_response_1 = require("./financial-common.response");
exports.CREDIT_ADVANCE_DEPOSIT_RESPONSE_EXAMPLE = {
    account: financial_common_response_1.FIN_ADVANCE_DEPOSIT_ACCOUNT_RESPONSE_EXAMPLE,
    transaction: financial_common_response_1.FIN_ADVANCE_DEPOSIT_TRANSACTION_RESPONSE_EXAMPLE,
    notificationSent: false,
};
exports.DEBIT_ADVANCE_DEPOSIT_RESPONSE_EXAMPLE = {
    account: { ...financial_common_response_1.FIN_ADVANCE_DEPOSIT_ACCOUNT_RESPONSE_EXAMPLE, balance: 400000 },
    transaction: { ...financial_common_response_1.FIN_ADVANCE_DEPOSIT_TRANSACTION_RESPONSE_EXAMPLE, transactionType: 'DEBIT', amount: 50000, balanceAfter: 400000 },
    notificationSent: false,
};
exports.SETTLE_DEPOSIT_RESPONSE_EXAMPLE = {
    account: { ...financial_common_response_1.FIN_ADVANCE_DEPOSIT_ACCOUNT_RESPONSE_EXAMPLE, balance: 0, status: 'SETTLED' },
    transaction: { ...financial_common_response_1.FIN_ADVANCE_DEPOSIT_TRANSACTION_RESPONSE_EXAMPLE, transactionType: 'SETTLEMENT', amount: 400000, balanceAfter: 0 },
    notificationSent: false,
};
//# sourceMappingURL=financial-advance-deposit.response.js.map